import script from "./RecommendOrders.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendOrders.vue?vue&type=script&setup=true&lang=ts"

import "./RecommendOrders.vue?vue&type=style&index=0&id=563849eb&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563849eb"]])

export default __exports__